import { __extends } from "tslib";
import { MetadataBase } from './MetadataBase';
var PropertyMetadata = /** @class */ (function (_super) {
    __extends(PropertyMetadata, _super);
    function PropertyMetadata(propertyName, type) {
        var _this = _super.call(this) || this;
        _this.propertyName = propertyName;
        _this.type = type;
        return _this;
    }
    PropertyMetadata.prototype.loadFromSchema = function (schema) {
        _super.prototype.loadFromSchema.call(this, schema);
        this.formatString = schema["x-formatString"];
        this.width = schema["x-width"];
        this.hAlign = schema["x-hAlign"];
    };
    return PropertyMetadata;
}(MetadataBase));
export { PropertyMetadata };
